module.exports = __webpack_public_path__ + "img/Zim.4e110e00.svg";